// Module
var code = "<h2 class=\"interiorSectionHeading\"> How It Works… </h2> <p>Forgives part or all of your educational loan debt, provided you fulfill certain work-related requirements.</p> <p><a class=\"more-link\" href=\"/manage/loan-forgiveness-discharge/teacher-loan-forgiveness\">Learn more about Teacher Loan Forgiveness</a></p> ";
// Exports
export default code;